interface DiggerLogoProps {
  className?: string;
  ariaLabel?: string;
}

const GREEN = '#4ab065';

export default function DiggerLogo({
  className,
  ariaLabel = 'DIGGER CDI',
}: DiggerLogoProps) {
  return (
    <svg
      viewBox="0 0 240 240"
      role="img"
      aria-label={ariaLabel}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{ariaLabel}</title>

      <path
        d="M 50 60 A 90 90 0 1 0 190 60"
        fill="none"
        stroke={GREEN}
        strokeWidth="6"
        strokeLinecap="round"
      />

      <g
        fill="none"
        stroke={GREEN}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="105" y="92" width="58" height="28" rx="3" />
        <line x1="118" y1="100" x2="118" y2="112" />
        <line x1="134" y1="100" x2="134" y2="112" />
        <line x1="150" y1="100" x2="150" y2="112" />

        <path d="M 105 100 L 88 80 L 72 78 L 60 92 L 78 110" />
        <circle cx="68" cy="86" r="3" fill={GREEN} />

        <rect x="96" y="124" width="76" height="20" rx="10" />
        <circle cx="106" cy="134" r="6" />
        <circle cx="124" cy="134" r="6" />
        <circle cx="144" cy="134" r="6" />
        <circle cx="162" cy="134" r="6" />
      </g>

      <text
        x="120"
        y="178"
        textAnchor="middle"
        fill="#ffffff"
        fontFamily="Montserrat, system-ui, sans-serif"
        fontWeight="900"
        fontSize="34"
        letterSpacing="2"
      >
        DIGGER
      </text>

      <text
        x="120"
        y="202"
        textAnchor="middle"
        fill="#ffffff"
        fontFamily="Montserrat, system-ui, sans-serif"
        fontWeight="700"
        fontSize="14"
        letterSpacing="1"
      >
        cdi
      </text>
      <text
        x="120"
        y="216"
        textAnchor="middle"
        fill={GREEN}
        fontFamily="Montserrat, system-ui, sans-serif"
        fontWeight="500"
        fontSize="8"
        letterSpacing="1.5"
      >
        PORTUGAL
      </text>
    </svg>
  );
}
